import { render, staticRenderFns } from "./Hongbao.vue?vue&type=template&id=21c04207&scoped=true&"
import script from "./Hongbao.vue?vue&type=script&lang=js&"
export * from "./Hongbao.vue?vue&type=script&lang=js&"
import style0 from "./Hongbao.vue?vue&type=style&index=0&id=21c04207&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c04207",
  null
  
)

export default component.exports